export const reduxKey = '@@CHAT';
export const actionKey = '@@CHAT';
export const pluginName = 'DeviantArt';
export const chatServerUrl = 'https://www.deviantart.com/_napi/shared_api/chat/';
export const maxGroupChatUsers = 20;

//# sourceMappingURL=constants.js.map